module.exports = __webpack_public_path__ + "img/holzdeck01.5662c118.webp";